import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import './VideoParallax.css';

const VideoParallax = () => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !videoRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
      const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

      videoRef.current.style.transform = `translateY(${(clampedProgress - 0.5) * -80}px) scale(1.1)`;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="video-parallax" ref={(el) => { containerRef.current = el; ref(el); }}>
      <div className="video-parallax__wrapper">
        <video
          ref={videoRef}
          className="video-parallax__video"
          autoPlay
          muted
          loop
          playsInline
          poster="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1920&q=80"
        >
          <source
            src="https://cdn.coverr.co/videos/coverr-fireworks-display-over-a-city-9498/1080p.mp4"
            type="video/mp4"
          />
        </video>
        <div className="video-parallax__overlay" />
      </div>

      <div className={`video-parallax__content ${inView ? 'video-parallax__content--visible' : ''}`}>
        <span className="video-parallax__label">Momenti Juaj, Magjia Jone</span>
        <h2 className="video-parallax__title">
          Le te krijojme dicka<br />
          <em>te jashtezakonshme</em> se bashku
        </h2>
        <a
          href="#contact"
          className="btn-primary"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <span>Na Kontaktoni</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default VideoParallax;
